import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import {TrackingContext} from '@homeaway/react-event-tracking';

import './Flags.less';

function Flags({items, showColumns}) {
    // Add the context to be used for pushing edap events
    const context = useContext(TrackingContext);
    const className = classNames('site-header-flags', {
        'site-header-flags--columns': showColumns
    });

    const edapTrigger = (text) => {
        const field = {
            actionlocation: `header.flag${text}`
        };
        context.trigger('header.link.click', field);
    };

    function onClickFlag(event) {
        const countryCode = event.currentTarget.dataset.countryCode;

        /* istanbul ignore next */
        if (countryCode && window.edap) {
            window.edap.push((edap) => {
                const payload = {
                    eventaction: 'header-countryflag',
                    eventcategory: 'react-site-header',
                    eventlabel: 'countryCode',
                    eventvalue: countryCode,
                };
                edap.trigger('generic.event', payload);
            });
        }
        edapTrigger(`.${countryCode}`);
    }

    function onClickFlagDropdown() {
        edapTrigger('');
    }

    // if there are no links then render nothing
    if (!items) {
        return null;
    }

    let currentFlag = items[0];

    // Render items
    const toggle = (
        <button
            aria-haspopup="true"
            className="site-header-flags__toggle"
        >
            <span className="sr-only">{currentFlag.text}</span>
            <i aria-hidden="true" className={`flag-${currentFlag.countryCode}`} />
        </button>
    );

    const renderItem = (flag) => (
        <a
            className={`site-header__link ${flag.countryCode}`}
            data-bypass="true"
            data-country-code={flag.countryCode}
            href={flag.link}
            key={`${flag.countryCode}-${flag.link}`}
            onClick={onClickFlag}
            role={'menuitem'}
        >
            <i aria-hidden="true" className={`site-header-flags__flag-icon flag-${flag.countryCode}`} />
            <span className="site-header-flags__flag-text">{flag.text}</span>
        </a>
    );

    return (
        <Dropdown
            className={className}
            customToggle={toggle}
            dropdownRight
            id="site-header-flags"
            label={currentFlag.text}
            tabIndex={-1}
            onDropdownShow={onClickFlagDropdown}
        >
            {items.map((flag, index) => (
                <DropdownItem className="site-header-flags__flag" key={flag.countryCode + index} text={renderItem(flag)} />
            ))}
        </Dropdown>
    );
}

Flags.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        countryCode: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    })),
    showColumns: PropTypes.bool
};

export {Flags};
